import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import ArrowDownCircle from './Icons/ArrowDownCircle.js';
import Info from './Icons/Info.js';
import X from './Icons/X.js';
const ButtonDrop = (props) => {
    const notButton = !!(props.info || props.arrow || props.customButton);
    const CustomButton = props.customButton;
    return (React.createElement("div", { style: { position: 'relative', display: 'inline-block' } },
        React.createElement(Button, { onClick: (e) => {
                e.stopPropagation();
                if (props.open) {
                    props.onClose();
                }
                else {
                    props.onOpen();
                }
            }, open: props.open, size: props.size, theme: notButton && 'transparent' }, CustomButton ? (CustomButton) : props.info ? (React.createElement(Info, { style: {
                width: '18px',
                height: '18px',
                margin: '-0.3em 0',
            } })) : (React.createElement(Add, { open: props.open, theme: props.arrow && 'transparent' }, props.arrow ? (React.createElement(ArrowDownCircle, { style: {
                width: '18px',
                height: '18px',
                margin: '-0.3em 0',
            } })) : (React.createElement(X, { style: {
                width: '14px',
                height: '14px',
                margin: '-0.3em 0',
            } }))))),
        props.open && (React.createElement(Floater, { open: props.open, maxWidth: props.maxWidth, minWidth: props.minWidth, dropDownPosition: props.dropDownPosition || 'below' }, props.children))));
};
export default ButtonDrop;
const Add = styled.div `
  font-weight: normal;
  color: ${(props) => props.theme === 'transparent' ? 'inherit' : THEME.COLOR_SECONDARY};
  transition: transform 0.05s ease-in-out;
  transform: rotate(
    ${(props) => props.open ? '0deg' : props.theme === 'transparent' ? '90deg' : '45deg'}
  );
`;
const Button = styled.div `
  text-align: center;
  cursor: pointer;
  transition: border-radius 0.2s ease-in-out;
  background: ${(props) => props.theme === 'transparent' ? 'none' : THEME.COLOR_ACCENT};
  display: inline-block;
  font-size: ${(props) => (props.size === 'mini' ? '0.6em' : '0.7em')};
  padding: ${(props) => props.size === 'small'
    ? '10px 15px'
    : props.size === 'mini'
        ? '6px 12px'
        : '0.25em'};
  border-radius: ${(props) => (props.open ? '3px 3px 0 0' : '3px')};
  box-shadow: ${(props) => props.theme === 'transparent' ? 'none' : '0 3px 6px rgba(0, 0, 0, 0.1)'};
`;
const Floater = styled.div `
  position: absolute;
  top: ${(props) => (props.dropDownPosition === 'below' ? '100%' : '0')};
  right: ${(props) => (props.dropDownPosition === 'below' ? '0' : '100%')};
  border: 1px solid ${THEME.COLOR_ACCENT};
  transition: opacity ${(props) => (props.open ? '0.15s' : '0.2s')};
  transition-delay: ${(props) => (props.open ? '0.05s' : '0s')};
  opacity: ${(props) => (props.open ? 1 : 0)};
  pointer-events: ${(props) => (props.open ? 'auto' : 'none')};
  background: ${THEME.COLOR_SECONDARY};
  border-radius: 5px 0 5px 5px;
  max-width: ${(props) => props.maxWidth || '400px'};
  min-width: ${(props) => props.minWidth || '220px'};
  z-index: 12;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  font-weight: normal;
`;
//# sourceMappingURL=ButtonDrop.js.map